import React from 'react';

import { LogOut } from 'react-feather';
import { Link } from 'react-router-dom';

import { useAuthActions, useAuthState } from 'contexts/AuthContext';
import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { authModel } from 'models';
import { ROUTES } from 'routes/constants';
import { CATEGORY_NAMES, METRIC_EVENT_NAMES } from 'metrics/constants';
import { useMatomo } from 'contexts/MatomoContext';

import { IconButton, Grid, PreviewText } from './style';

export function ProfilePreview() {
  const {
    currentUser: { attributes },
  } = useAuthState();
  const { logOut } = useAuthActions();
  const { handleServerError } = useServerErrorActions();
  const { trackEvent } = useMatomo()

  const handleSignOut = () => {
    trackEvent({ category: CATEGORY_NAMES.PUBTOOL_EVENTS, action: 'click', name: METRIC_EVENT_NAMES.LOGOUT });
    authModel.signOut().then(logOut).catch(handleServerError);
  }

  return (
    <Grid container alignItems="center" justify="space-between">
      <Grid className="admin-name" component={Link} to={ROUTES.profile}>
        <PreviewText>{attributes.email}</PreviewText>
      </Grid>
      <Grid item>
        <IconButton onClick={handleSignOut}>
          <LogOut />
        </IconButton>
      </Grid>
    </Grid>
  );
}
